/* eslint-disable react/jsx-key */
import React from "react";
import { TD, TR } from "../../../../../../styled";

const Content = ({ data, prepareRow }) => {
  return data.map((row) => {
    prepareRow(row);
    return (
      <TR {...row.getRowProps()} isExpanded={row.isExpanded && row.original.articleDescription !== ""}>
        {row.cells.map((cell) => {
          return (
            <TD {...cell.getCellProps()} isExpanded={row.isExpanded && row.original.articleDescription !== ""}>
              {cell.render("Cell")}
            </TD>
          );
        })}
      </TR>
    );
  });
};

export default Content;
